import { createSlice } from '@reduxjs/toolkit';

const customerOnCallSlice = createSlice({
  name: 'customerOnCall',
  initialState: {
    driverListOnCallData: [],
    driverListOnCallDataIsLoading: false,
    driverListOnCallDataErrorMsg: null,

    getdriverOnCallData: [],
    getdriverOnCallDataIsLoading: false,
    getdriverOnCallDataErrorMsg: null,

    submitRettingData: [],
    submitRettingDataIsLoading: false,
    submitRettingDataErrorMsg: null,

    driverNotificationData: [],
    driverNotificationDataIsLoading: false,
    driverNotificationDataErrorMsg: null,
  },
  reducers: {
    driverListOnCallReq: (state, action) => { },
    driverListOnCallSuccess: (state, action) => ({
      ...state,
      driverListOnCallData: action.payload,
      driverListOnCallDataIsLoading: false,
      driverListOnCallDataErrorMsg: null,
    }),
    driverListOnCallFailure: (state, action) => ({
      ...state,
      driverListOnCallDataIsLoading: false,
      driverListOnCallDataErrorMsg: action.payload,
    }),
    driverListOnCallLoading: (state) => ({
      ...state,
      driverListOnCallDataIsLoading: true,
      driverListOnCallDataErrorMsg: null,
    }),
    driverListOnCallClear: (state) => ({
      ...state,
      driverListOnCallData: [],
      driverListOnCallDataIsLoading: false,
      driverListOnCallDataErrorMsg: null,
    }),

    getdriverOnCallReq: (state, action) => { },
    getdriverOnCallSuccess: (state, action) => ({
      ...state,
      getdriverOnCallData: action.payload,
      getdriverOnCallDataIsLoading: false,
      getdriverOnCallDataErrorMsg: null,
    }),
    getdriverOnCallFailure: (state, action) => ({
      ...state,
      getdriverOnCallDataIsLoading: false,
      getdriverOnCallDataErrorMsg: action.payload,
    }),
    getdriverOnCallLoading: (state) => ({
      ...state,
      getdriverOnCallDataIsLoading: true,
      getdriverOnCallDataErrorMsg: null,
    }),
    getdriverOnCallClear: (state) => ({
      ...state,
      getdriverOnCallData: [],
      getdriverOnCallDataIsLoading: false,
      getdriverOnCallDataErrorMsg: null,
    }),

    submitRettingReq: (state, action) => { },
    submitRettingSuccess: (state, action) => ({
      ...state,
      submitRettingData: action.payload,
      submitRettingDataIsLoading: false,
      submitRettingDataErrorMsg: null,
    }),
    submitRettingFailure: (state, action) => ({
      ...state,
      submitRettingDataIsLoading: false,
      submitRettingDataErrorMsg: action.payload,
    }),
    submitRettingLoading: (state) => ({
      ...state,
      submitRettingDataIsLoading: true,
      submitRettingDataErrorMsg: null,
    }),
    submitRettingClear: (state) => ({
      ...state,
      submitRettingData: [],
      submitRettingDataIsLoading: false,
      submitRettingDataErrorMsg: null,
    }),

    driverNotificationReq: (state, action) => { },
    driverNotificationSuccess: (state, action) => ({
      ...state,
      driverNotificationData: action.payload,
      driverNotificationDataIsLoading: false,
      driverNotificationDataErrorMsg: null,
    }),
    driverNotificationFailure: (state, action) => ({
      ...state,
      driverNotificationDataIsLoading: false,
      driverNotificationDataErrorMsg: action.payload,
    }),
    driverNotificationLoading: (state) => ({
      ...state,
      driverNotificationDataIsLoading: true,
      driverNotificationDataErrorMsg: null,
    }),
    driverNotificationClear: (state) => ({
      ...state,
      driverNotificationData: [],
      driverNotificationDataIsLoading: false,
      driverNotificationDataErrorMsg: null,
    }),
  },
});

export const {
  driverListOnCallClear,
  driverListOnCallFailure,
  driverListOnCallLoading,
  driverListOnCallReq,
  driverListOnCallSuccess,

  getdriverOnCallReq,
  getdriverOnCallSuccess,
  getdriverOnCallFailure,
  getdriverOnCallLoading,
  getdriverOnCallClear,

  submitRettingReq,
  submitRettingSuccess,
  submitRettingFailure,
  submitRettingLoading,
  submitRettingClear,

  driverNotificationReq,
  driverNotificationSuccess,
  driverNotificationFailure,
  driverNotificationLoading,
  driverNotificationClear,
} = customerOnCallSlice.actions;

export default customerOnCallSlice.reducer;
